export const USER_ROLES = {
    ADMIN: 'admin',
    USER: 'user',
};

export const isAdminRole = (role) => role === USER_ROLES.ADMIN;